import * as Cookies from "js-cookie";

import { environment } from "../config/environment";
import { fetchJson } from "../../fetch";
import { isUnderAARPDomain } from "../../utils";
import { KeysEnum } from "../models/Enums";
import { User } from "../models/User";
import AARPAuthService from "./AARPAuthService";
import { LocalStorageService } from "./LocalStorage";

class AuthService {
  public authFetch(url: string, options?: any, jsonResponse?: boolean) {
    const token = this.getToken();

    if (!token) {
      return Promise.reject();
    }

    options = options || {};
    // Edge fix
    options.headers = new Headers(options.headers || {});
    options.headers.set("Authorization", `Bearer ${token}`);

    return fetchJson(url, options, jsonResponse);
  }

  // If token exist, put it to localStorage and remove from url, preserving all other query params
  public handleToken() {
    const url = new URL(window.location.href);
    const token = url.searchParams.get(KeysEnum.arkToken);
    const aarpToken = Cookies.get(KeysEnum.aarpCookieToken) || "";
    const aarpIdToken = Cookies.get(KeysEnum.aarpCookieIdToken) || "";

    if (token) {
      window.localStorage.setItem(KeysEnum.arkToken, token);
      window.localStorage.setItem(KeysEnum.aarpToken, aarpToken);
      window.localStorage.setItem(KeysEnum.idToken, aarpIdToken);

      //temporary
      const aarpTokenExpiresIn =
        Date.now() + environment.REWARD_TOKEN_EXPIRATION * 1000;
      window.localStorage.setItem(
        KeysEnum.aarpTokenExpiresIn,
        aarpTokenExpiresIn.toString()
      );

      try {
        (window as any).AARP.store.subscribe(() => {
          (window as any).AARP.checkLoyaltyPoints();
        });
        (window as any).AARP.store.dispatch({ type: "OAUTH_TOKEN_READ" });
      } catch (e) {
        console.error(e);
      }

      const expiresIn = Date.now() + environment.ARENA_TOKEN_EXPIRATION * 1000;
      window.localStorage.setItem(
        KeysEnum.arkTokenExpiresIn,
        expiresIn.toString()
      );

      url.searchParams.delete(KeysEnum.arkToken);

      if (window.history.pushState) {
        window.history.pushState({ path: url.href }, "", url.href);
      } else {
        window.location.replace(url.href);
      }
    }

    AARPAuthService.init();
  }

  public redirectToLogin() {
    window.location.replace(AARPAuthService.getLoginUrl());
  }

  public redirectToNewLogin() {
    window.location.replace(AARPAuthService.getNewLoginUrl());
  }

  public authUser(): Promise<User> {
    const arkToken = this.getToken();

    // For development
    if (!isUnderAARPDomain()) {
      if (arkToken) {
        return this.fetchUser();
      }
      return Promise.reject(null);
    }

    // Not aarp-logged -> clear ark token to sync
    if (!this.isAARPLogged()) {
      this.resetToken();
      return Promise.reject(null);
    }

    // Is aarp-logged but no ark token -> force login to sync
    if (!arkToken) {
      this.redirectToLogin();
      return Promise.reject(null);
    }

    return this.fetchUser().catch((err) => {
      // Since secret will be changed, can't rely on expiration time
      // if (this.tokenHasExpired()) {
      // }
      this.resetToken();
      this.redirectToLogin();

      throw null;
    });
  }

  public getToken() {
    return window.localStorage.getItem(KeysEnum.arkToken);
  }

  public tokenHasExpired() {
    const expiresIn = LocalStorageService.getItem(KeysEnum.arkTokenExpiresIn);
    return expiresIn ? Date.now() >= parseInt(expiresIn, 10) : false;
  }

  public aarpTokenHasExpired() {
    const expiresIn = LocalStorageService.getItem(KeysEnum.aarpTokenExpiresIn);
    return Date.now() >= parseInt(expiresIn, 10);
  }

  private fetchUser() {
    if (this.aarpTokenHasExpired()) {
      this.redirectToLogin();
      return Promise.reject(null);
    }

    return this.authFetch(environment.USER_API + "/user")
      .then((user: User) => {
        console.info("User was recognized: ", user.name);
        return user;
      })
      .catch((err) => {
        // Login loop is possible
        this.resetToken();
        throw err;
      });
  }

  private isAARPLogged() {
    return !!Cookies.get(KeysEnum.aarpAT);
  }

  private resetToken() {
    window.localStorage.removeItem(KeysEnum.arkToken);
    window.localStorage.removeItem(KeysEnum.arkTokenExpiresIn);
  }
}

export default new AuthService();
